<template>
  <div class="rankings">
    <h2 class="title-lined">
      <div class="title-line">TOP 10 DO MÊS</div>
    </h2>
    <div class="stats-table table-responsive">
      <table class="table table-sm is-hoverable">
        <thead>
          <tr>
            <th></th>
            <th>
              <abbr title="Nome">Nome</abbr>
            </th>
            <!-- <th><abbr title="Frags divido por Mortes">KDR</abbr></th>
            <th><abbr title="Frags médios por round">KPR</abbr></th>
            <th><abbr title="Dano médio por round">ADR</abbr></th>-->
            <th>
              <abbr title="QUEOTA.club score">Score</abbr>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(player, index) in players" :key="player.id">
            <td>{{index+1}}</td>
            <td v-if="player.user" class="user-column">
              <router-link :to="{ name: 'UserSingle', params: { id: player.user.id }}">
                <div class="user-image">
                  <b-img
                    rounded="circle"
                    width="16"
                    :src="player.user.avatar"
                    :alt="player.user.nickname"
                  />
                </div>
                {{player.user.nickname}}
              </router-link>
            </td>
            <td v-if="!player.user">{{ player.name }}</td>
            <!-- <td>{{ player.kdr }}</td>
            <td>{{ player.kpr }}</td>
            <td>{{ player.adr }}</td>-->
            <td>{{ player.queota_score }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <small>
      <router-link to="/ranked_stats">veja o ranking completo</router-link>
    </small>
  </div>
</template>

<script>
export default {
  name: "MiniRanking",
  props: {
    players: Array
  }
};
</script>

<style lang="sass">
.rankings
  margin-top: 0px
  margin-bottom: 20px
  h5
    color: #888
  .stats-table table
    background: transparent !important
    margin-bottom: 5px
    color: #777
    thead
      th
        border-bottom: 1px solid rgba(255, 255, 255, .05)
    td, th
      border-top: none!important
      transition: all .1s
    td:first-child
      text-align: right
    td.user-column
      font-weight: normal
      color: #888
      a
        color: #888
        transition: all .1s
        &:hover
          text-decoration: none
    td:last-child
      font-weight: normal
      color: #777
      text-align: right
    th:last-child
      text-align: right

    tr:hover
      td
        font-weight: bold
        color: white
        a
          color: white

    .user-image
      float: left
      margin-right: 5px
      position: relative
      top: -2px
      img
        opacity: .4
  small
    display: block
    text-align: right
</style>

